export abstract class ObjectUtils
{
    public static shallowCompareKeys(objA:object, objB:object):boolean
    {
        if( objA == null && objB == null )
            return true;
        else if( objA == null || objB == null )
            return false;
        else if( Array.isArray(objA) || Array.isArray(objB) )
            return false;
        else
        {
            const keysA = Object.keys(objA);
            const keysB = Object.keys(objB);

            if( keysA.length !== keysB.length )
                return false;

            for( let i = 0; i < keysA.length; i++ )
            {
                if( !objB.hasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]] )
                    return false;
            }

            return true;
        }
    }

    public static merge(objA, objB):Object
    {
        const recursiveMerge = (obj, entries) =>
        {
             for( const [key, value] of entries )
             {
                if( typeof value === "object" )
                {
                   obj[key] = obj[key] ? {...obj[key]} : {};
                   recursiveMerge(obj[key], Object.entries(value))
                }
                else
                {
                   obj[key] = value;
                }
            }
            return obj;
        }
    
        return recursiveMerge(objA, Object.entries(objB))
    }
}
